import { Card } from '@lilith-arcana-os/ui';

interface LibraryCachePanelProps {
  readings: number;
  cards: number;
  spreads: number;
  queue: number;
}

export function LibraryCachePanel({ cards, queue, readings, spreads }: LibraryCachePanelProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Card eyebrow="IndexedDB" title="Cache letture">
        <p className="text-4xl font-heading text-[var(--la-text)]">{readings}</p>
      </Card>
      <Card eyebrow="IndexedDB" title="Cache carte">
        <p className="text-4xl font-heading text-[var(--la-text)]">{cards}</p>
      </Card>
      <Card eyebrow="IndexedDB" title="Cache spreads">
        <p className="text-4xl font-heading text-[var(--la-text)]">{spreads}</p>
      </Card>
      <Card eyebrow="Sync" title="Queue differita">
        <p className="text-4xl font-heading text-[var(--la-text)]">{queue}</p>
      </Card>
    </div>
  );
}
